<template>
  <div class="top_layout">
    <div class="loading" v-show="loading">
      <img class="Rotation" src="@/assets/loading.png">
    </div>
    <div class="flex_vertial" v-show="!loading" style="  background: #3265E4;">
      <img class="head_img" src="../assets/irobot.png">
      <div class="top_title">电话漏接不想接<br>智能助理帮你接</div>

      <div class="play_layout">
        <div class="title_layout">
          <div class="titl1">重要电话不错过</div>
          <div class="titl2">客户来电案例</div>
        </div>
        <div style="flex:1;"></div>
        <img src="../assets/wave.png" class="wave">
        <img :src="isStore1 ? startIcon : stopIcon" @click="changeStart1" class="play_box">
        <audio src="https://xcx-75803.gzc.vod.tencent-cloud.com/img/mp3/demo_kfdj.mp3" id="musicMp3_1" controls=""
               style="display: none"></audio>
      </div>
      <div class="play_layout">
        <div class="title_layout">
          <div class="titl1">骚扰电话放心挂</div>
          <div class="titl2">广告来电案例</div>
        </div>
        <div style="flex:1;"></div>
        <img src="../assets/wave.png" class="wave">
        <img :src="isStore2 ? startIcon : stopIcon" @click="changeStart2" class="play_box">
        <audio src="https://yycdn-75403.gzc.vod.tencent-cloud.com/Real_Estate_Agents_Sample_CDR.wav" id="musicMp3_2"
               controls="" style="display: none"></audio>
      </div>
      <div style="flex:1;"></div>
      <div class="open_button" @click="login">领取我的电话助理</div>
      <div class="tail_tips">每一通电话都有语音和文字记录</div>
    </div>
  </div>
</template>

<script>

import app from '@/AppData'
import jsbridge from '@/jsbridge'
import ic_play_icon from '@/assets/ic_play.png'
import ic_stop_icon from '@/assets/ic_pause.png'
import {SERVICE_SWITCH} from '@/utils/const'
import TitleBarStore from '@/components/widgets/TitleBarStore'
import lubanApi from '@/lubanApi'
import util from '@/utils/util'

const ENV = require('@/env.js')

const TAG = '[Logining]'

export default {
  name: 'Logining',
  data () {
    return {
      loading: true,
      needLogin: false,
      startIcon: ic_play_icon,
      stopIcon: ic_stop_icon,
      isStore1: true,
      play_tips1: '客户来电案例',
      isStore2: true,
      play_tips2: '广告来电案例',
      isPhoneAccount: false
    }
  },
  methods: {
    /**
     * 首页检查账号，有账号后初始化luban;
     * 没有请求登录后再初始化
     */
    checkAccount (auto = true) {
      var that = this
      console.log('accountId from json ' + JSON.stringify(app.getData().accountId))
      if (app.getData().accountId != null) {
        that.initLuban()
      } else {
        console.log('getAccountId from bridge')
        jsbridge.getAccountId().then(res => {
          that.isPhoneAccount = false
          console.log('getAccountId res ', res)
          app.setData('accountId', res)
          that.initLuban()
        }).catch(err => {
          console.error(err)
          if (err == 'phone') {
            that.isPhoneAccount = true
            if (!auto) {
              that.showPhoneAccountAlert()
            }
          } else {
            that.isPhoneAccount = false
          }
          that.needLogin = true
          that.hideLoading()

          lubanApi.reportseer('AICall_Open_Function_Introduction_Page_Shown')

          if (err == null) {
            console.log(TAG, 'account is null, need login')
          } else {
            util.Toast('登录失败, 请退出并重新进入')
          }
        })
      }
    },

    showPhoneAccountAlert () {
      util.Toast('不支持手机号登录，请先退出再切换为微信或者QQ登录')
    },

    async initLuban () {
      // 初始化luban
      console.log('init luban sdk')
      var that = this

      try {
        await jsbridge.initLuban()
      } catch (err) {
        console.log(err)
      }
      console.log('init luban end')
      let forceLogin = app.getData().needRelogin === true
      wx.lb.login(forceLogin).then(userInfo => {
        console.log('getUserInfo ' + JSON.stringify(userInfo))
        app.initBaseData(true, true).then(res => {
          if (!app.getData().userSetting ||
            app.getData().userSetting.phoneNum === '') {
            // 跳转绑定页面
            that.hideLoading()
            console.log('needBind', app.getData().userSetting)
            // 登录成功情况下，点击，直接进入绑定页面
            if (that.needLogin) {
              this.$router.push({
                path: '/bind_phone'
              })
            } else {
              // wait user click bind
              console.log(TAG, 'wait user click bind_phone')
              lubanApi.reportseer('AICall_Open_Function_Introduction_Page_Shown')
            }
            jsbridge.setBindNum('')
          } else {
            console.log(TAG, 'login success')
            if (app.getLocalStorage(SERVICE_SWITCH.NAME) === SERVICE_SWITCH.STATE_NEED_SET_CALLFORWARD) {
              this.$router.replace({
                path: '/bind_call_forward'
              })
            } else {
              that.redirectBack()
            }
            jsbridge.setBindNum(app.getData().userSetting.phoneNum)
          }
        }).catch(err => {
          console.log('err', err)
        })
      }).catch(err => {
        console.log('getuserInfo failed: ', err)
        util.Toast('登录失败, 请退出并重新进入')
      })
    },

    redirectBack () {
      console.log(TAG, 'login redirectBack', this.$route.query)
      if (this.$route.query && this.$route.query.redirect) {
        let redirect_path = this.$route.query.redirect
        this.$router.replace({path: redirect_path})
      } else {
        this.$router.replace({path: '/'})
      }
    },

    login () {
      console.log(TAG, 'login')
      var that = this
      if (this.isPhoneAccount) {
        this.showPhoneAccountAlert()
        return
      }
      if (this.needLogin) {
        jsbridge.loginApp().then(res => {
          // 登录成功，返回back
          console.log(TAG, 'login success')
          that.checkAccount(false)
        }).catch(err => {
          // 提示，toast提示
          console.log(TAG, 'loginApp', err)
          util.Toast('登录失败, 请退出并重新进入')
        })
      } else {
        this.$router.replace({
          path: '/bind_phone'
        })
      }
      lubanApi.reportseer('AICall_Open_Function_Introduction_Page_Open_Button_Click')
    },

    // UI相关
    changeStart1 () {
      this.isStore1 = !this.isStore1
      const musicMp3_1 = document.getElementById('musicMp3_1')
      const musicMp3_2 = document.getElementById('musicMp3_2')
      musicMp3_2.pause()
      musicMp3_2.currentTime = 0
      this.isStore2 = true
      if (!this.isStore1) {
        musicMp3_1.play()
        console.log('musicMp3.play')
      } else {
        musicMp3_1.pause()
        console.log('musicMp3.pause')
      }
    },
    changeStart2 () {
      this.isStore2 = !this.isStore2
      const musicMp3_1 = document.getElementById('musicMp3_1')
      const musicMp3_2 = document.getElementById('musicMp3_2')
      musicMp3_1.pause()
      musicMp3_1.currentTime = 0
      this.isStore1 = true
      if (!this.isStore2) {
        musicMp3_2.play()
        console.log('musicMp3.play')
      } else {
        musicMp3_2.pause()
        console.log('musicMp3.pause')
      }
    },
    watchProgress () {
      const musicMp3_1 = document.getElementById('musicMp3_1')
      const musicMp3_2 = document.getElementById('musicMp3_2')
      var that = this

      musicMp3_1.addEventListener('canplay', function () {
        that.updatePlayTips(musicMp3_1)
      })

      musicMp3_2.addEventListener('canplay', function () {
        that.updatePlayTips(musicMp3_2)
      })

      musicMp3_1.addEventListener('timeupdate', function () {
        const numbers = musicMp3_1.currentTime / musicMp3_1.duration
        let perNumber = (numbers * 100).toFixed(2)
        console.log('perNumber', perNumber)
        if (perNumber >= 100) {
          perNumber = 0
          that.isStore1 = true
        }
        that.updatePlayTips(1, musicMp3_1, perNumber)
      })

      musicMp3_2.addEventListener('timeupdate', function () {
        const numbers = musicMp3_2.currentTime / musicMp3_2.duration
        let perNumber = (numbers * 100).toFixed(2)
        console.log('perNumber', perNumber)
        if (perNumber >= 100) {
          perNumber = 0
          that.isStore2 = true
        }
        that.updatePlayTips(2, musicMp3_2, perNumber)
      })
    },

    updatePlayTips (index, musicMp3, perNumber) {
      if (index === 1) {
        if (this.isStore1) {
          console.log('this.perNumber1', perNumber)
          if (perNumber == 0) {
            this.play_tips1 = '客户来电案例'
          } else {
            this.play_tips1 = '暂停 '
          }
        } else {
          this.play_tips1 = '播放中 '
        }
      } else if (index === 2) {
        if (this.isStore2) {
          console.log('this.perNumber2', perNumber)
          if (perNumber == 0) {
            this.play_tips2 = '广告来电案例'
          } else {
            this.play_tips2 = '暂停 '
          }
        } else {
          this.play_tips2 = '播放中 '
        }
      }
    },

    hideLoading () {
      this.loading = false
      TitleBarStore.store.hideBack()
      TitleBarStore.store.changeWhiteText(true)
      TitleBarStore.store.changeBackGround('#3265E4')
    }
  },

  mounted () {
    console.log(TAG, 'mounted')
    // dom渲染后执行
    var that = this
    this.$nextTick(() => {
      that.watchProgress()
    })

    TitleBarStore.store.hideBack()
    if (!this.loading) {
      TitleBarStore.store.changeWhiteText(true)
      TitleBarStore.store.changeBackGround('#3265E4')
    }
    // 先检查平台，用户统计点上报
    jsbridge.getPlatform()
    this.checkAccount(true)
    jsbridge.checkNeedShowNotification()
  },

  destroyed () {
    const musicMp3_1 = document.getElementById('musicMp3_1')
    const musicMp3_2 = document.getElementById('musicMp3_2')
    if (musicMp3_1 != undefined) {
      musicMp3_1.onpause()
      musicMp3_1.currentTime = 0
    }

    if (musicMp3_2 != undefined) {
      musicMp3_2.onpause()
      musicMp3_2.currentTime = 0
    }
  }
}
</script>
<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>

.top_layout {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}


.play_layout {
  position: relative;
  width: calc(88%);

  height: 5.3rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 0.7rem;
  margin-bottom: 0.75rem;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center;

  padding-left: 0.8rem;
  padding-right: 0.8rem;
}

.play_img1 {
  position: absolute;
  height: 9.5rem;
  width: 9.5rem;
  right: 0.4rem;
  top: 0.2rem;
}

.play_img2 {
  position: absolute;
  height: 6.9rem;
  width: 9.77rem;
  right: 0.2rem;
}

.play_title {
  position: absolute;
  font-family: PingFangSC-Medium;
  font-family: PingFangSC-Medium;
  font-size: 1.25rem;
  color: #000000;
  letter-spacing: 0.04rem;
  line-height: 1.7rem;
  left: 1.35rem;
  top: 1.35rem;
  font-weight: 900;
}

.play_box {
  height: 2rem;
  width: 2rem;
  display: flex;
}

.play_box img {
  width: 1.94rem;
  height: 1.94rem;
  z-index: 999;
}

.play_tips {
  width: 7rem;
  height: 1.6rem;
  font-size: 0.8rem;
  line-height: 1.6rem;
  margin-left: -0.5rem;
  border-radius: 0 1.5rem 1.5rem 0;
  font-family: PingFangSC-Medium;
  color: #2289FF;
  background: #EAF5FF;
}

.open_button {
  margin-top: 1.5rem;
  z-index: 1;
}

.head_img {
  width: 10rem;
  height: 10rem;
  margin-bottom: -1rem;
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 121;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading img {
  width: 20%;
  z-index: 999;
}

.tail_tips {
  opacity: 0.6;
  font-family: PingFangSC-Regular;
  font-size: 0.815rem;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 1rem;
}

.top_title {
  font-family: PingFangSC-Medium;
  font-size: 1.25rem;
  color: #FFFFFF;
  text-align: center;
  line-height: 2.22rem;
  margin-bottom: 1.2rem;
}

.title_layout {

}

.titl1 {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #FFFFFF;
}

.titl2 {
  opacity: 0.5;
  font-family: PingFangSC-Regular;
  font-size: 0.815rem;
  color: #FFFFFF;
  text-align: left;
  margin-top: 0.6rem;
}

.wave {
  width: 5rem;
  height: 1.78rem;
  margin-right: 0.6rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Logining2.vue